import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Included apps

import { THEME_CONFIG, getConfigValue, ThemeSystemProvider } from '@amtrav/theme-system';
import { connectLoggedOutZendesk, OpenButton } from '../apps/chat';

const { theme } = document.querySelector('body').dataset;

type ThemeName = React.ComponentProps<typeof ThemeSystemProvider>['themeName'];

function Opener() {
  const chatWidgetColors = getConfigValue(THEME_CONFIG.chat.widget.colors);
  const opener = connectLoggedOutZendesk({
    theme: chatWidgetColors,
  })
  return <OpenButton onClick={opener} />
}

Modal.setAppElement('#chatContainer');
ReactDOM.render(
  <ThemeSystemProvider themeName={theme as ThemeName}>
    <Opener />
  </ThemeSystemProvider>,
  document.getElementById('chatContainer'),
);
